/**
 * Keeps dashing-ui's component overrides in sync with the current brand/flags.
 * - `VisionPrediction.topPerformingMediaUrl` per current brand.
 * - YouTube-compliance channel icon styling when the flag is off.
 */

// Side-effect imports — register each component's `DashingUIOverrideRegistry` augmentation.
import '@dashhudson/dashing-ui/vision-prediction';
import '@dashhudson/dashing-ui/channel-icon';
import '@dashhudson/dashing-ui/channel-icon-button';
import { setDashingUIOverrides } from '@dashhudson/dashing-ui/plugin';
import { watch } from 'vue';

import { useFlagStore } from '@/stores/flag';
import { useIdentityStore } from '@/stores/identity';

// Library, filtered to top + above-average predictions, sorted by predicted performance desc.
function topPerformingMediaUrlFor(brandLabel: string): string {
  const params = new URLSearchParams({ performance: 'top,high', sort: '-PERFORMANCE' });
  return `/${brandLabel}/library/discover?${params.toString()}`;
}

export default {
  install() {
    const identityStore = useIdentityStore();
    const flagStore = useFlagStore();

    watch(
      () => identityStore.currentBrandLabel,
      (brandLabel) => {
        setDashingUIOverrides('vision-prediction', {
          topPerformingMediaUrl: brandLabel ? topPerformingMediaUrlFor(brandLabel) : undefined,
        });
      },
      { immediate: true },
    );

    // When YouTube compliance is off, render channel icons as neutral avatars and
    // the larger black ChannelIconButton treatment, app-wide.
    watch(
      () => flagStore.ready && flagStore.flags?.youtubeCompliance,
      (isCompliant) => {
        setDashingUIOverrides('channel-icon', isCompliant ? null : { variant: 'avatar' });
        setDashingUIOverrides(
          'channel-icon-button',
          isCompliant ? null : { size: 64, fill: 'black' },
        );
      },
      { immediate: true },
    );
  },
};
